import { render, staticRenderFns } from "./HomeCompletedProjectCard.vue?vue&type=template&id=59ce5dec"
import script from "./HomeCompletedProjectCard.vue?vue&type=script&lang=js"
export * from "./HomeCompletedProjectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports